import { Component, Input, OnInit } from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { format, render, cancel, register } from "timeago.js";
import { environment } from "../../../environments/environment";
import { User } from "../../@core/data/users";
import { DialogProfileComponent } from "../dialog-profile/dialog-profile.component";

@Component({
  selector: "ngx-view-user-display",
  styleUrls: ["./view-user-display.component.scss"],
  templateUrl: "./view-user-display.component.html",
})
export class ViewUserDisplayComponent implements OnInit {
  @Input() user?: User;
  @Input() mode?: string = "name"; //name / avatar / detail
  @Input() icon?: string = ""; //at-outline
  @Input() uid?: string = "";
  @Input() name?: string = "";

  imagePath: string =
    environment.imageKit.urlEndpoint + "/tr:n-media_library_thumbnail/users/";
  imageURL = "";

  constructor(private dialogService: NbDialogService) {}

  ngOnInit(): void {
    if (this.user) {
      this.uid = this.user.uid;
      this.name = this.user.displayName;
      this.imageURL = this.user.photoURL
        ? this.user.photoURL.replace(
            "https://ik.imagekit.io/kasoft/",
            "https://ik.imagekit.io/kasoft/tr:n-media_library_thumbnail/"
          )
        : "https://ik.imagekit.io/kasoft/tr:n-media_library_thumbnail/users/default";
    } else {
      this.imageURL =
        "https://ik.imagekit.io/kasoft/tr:n-media_library_thumbnail/users/default";
      this.name = "Ẩn danh";
    }
  }

  viewProfile(userId) {
    this.dialogService.open(DialogProfileComponent, {
      context: {
        header: "Thông tin tài khoản",
        userId: userId,
      },
      closeOnBackdropClick: false,
    });
  }
}
